"use strict";
'use es6'; // API Level access control checks

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FREQUENCY_WRITE = exports.FREQUENCY_READ = exports.TYPES_WRITE = exports.TYPES_READ = exports.TRACKING_WRITE = exports.TRACKING_READ = exports.SUBSCRIPTION_PAGE_WRITE = exports.SUBSCRIPTION_PAGE_READ = exports.SMTP_TOKENS_TAB_READ = exports.SIZE_SETTINGS_WRITE = exports.SIZE_SETTINGS_READ = exports.RSS_DATE_FORMAT_WRITE = exports.RSS_DATE_FORMAT_READ = exports.RESUBSCRIPTION_EMAIL_WRITE = exports.RESUBSCRIPTION_EMAIL_READ = exports.GRAYMAIL_SUPPRESSION_WRITE = exports.GRAYMAIL_SUPPRESSION_READ = exports.FOOTER_CARDS_WRITE = exports.FOOTER_CARDS_READ = exports.FONT_SETTINGS_WRITE = exports.FONT_SETTINGS_READ = exports.DOUBLE_OPTIN_WRITE = exports.DOUBLE_OPTIN_TURN_OFF = exports.DOUBLE_OPTIN_PANEL = exports.DOUBLE_OPTIN_READ = exports.DEFAULT_SETTINGS_READ = exports.COLOR_PICKER_SETTINGS_WRITE = exports.COLOR_PICKER_SETTINGS_READ = exports.COLOR_SETTINGS_WRITE = exports.COLOR_SETTINGS_READ = exports.DEFAULT_SETTINGS_WRITE = exports.BCC_EMAIL_SETTINGS_WRITE = exports.BCC_EMAIL_SETTINGS_READ = exports.SMTP_TOKENS_WRITE = exports.SMTP_TOKENS_READ = exports.EMAIL_PAID_ACCESS = exports.EMAIL_SETTINGS_READ = exports.SITE_SETTINGS_WRITE = void 0;
var BCC_EMAIL_WRITE = {
  matchesAllScopes: ['content-settings-access', 'email-access']
};
var BLOG_LANGUAGES_READ = {
  matchesAllScopes: ['content-access']
};
var CAN_SPAM_SETTINGS_READ = {
  matchesSomeScopes: ['content-access', 'can-spam-settings-access']
};
var CAN_SPAM_SETTINGS_WRITE = {
  matchesSomeScopes: ['can-spam-settings-access', 'content-settings-access']
};
var DESIGN_TEMPLATES_READ = {
  matchesAllScopes: ['content-access']
};
var DOI_PAGES_READ = {
  matchesSomeScopes: ['contacts-access', 'email-access']
};
var DOI_PAGES_WRITE = {
  matchesAllScopes: ['content-settings-access', 'email-access']
};
var DOI_SETTINGS_READ = {
  matchesSomeScopes: ['contacts-access', 'email-access']
};
var DOI_SETTINGS_WRITE = {
  matchesAllScopes: ['content-settings-access', 'email-access']
};
var DOMAINS_READ = {
  matchesAllScopes: ['content-access']
};
var LANDING_PAGES_READ = {
  matchesAllScopes: ['content-access']
};
var SITE_SETTINGS_READ = {
  matchesAllScopes: ['content-access', 'content-core-api-access']
};
var SITE_SETTINGS_WRITE = {
  matchesAllScopes: ['content-settings-access']
};
exports.SITE_SETTINGS_WRITE = SITE_SETTINGS_WRITE;
var EMAIL_SETTINGS_READ = {
  or: [{
    matchesAllScopes: ['email-editor-access']
  }]
};
exports.EMAIL_SETTINGS_READ = EMAIL_SETTINGS_READ;
var EMAIL_PAID_ACCESS = {
  matchesAllScopes: ['marketing-email-not-demo']
};
exports.EMAIL_PAID_ACCESS = EMAIL_PAID_ACCESS;
var SMTP_TOKENS_READ = {
  matchesSomeScopes: ['transactional-email', 'transactional-email-smtp']
};
exports.SMTP_TOKENS_READ = SMTP_TOKENS_READ;
var SMTP_TOKENS_WRITE = {
  matchesAllScopes: ['content-settings-access']
};
exports.SMTP_TOKENS_WRITE = SMTP_TOKENS_WRITE;
var SUBSCRIPTION_DEFINITIONS_READ = {
  matchesAllScopes: ['email-core-api-access']
};
var SUBSCRIPTION_DEFINITIONS_WRITE = {
  matchesAllScopes: ['email-core-api-access']
};
var SUBSCRIPTION_EMAILS_READ = {
  matchesAllScopes: ['email-access', 'content-core-api-access']
};
var EMAIL_FATIGUE_SUPRESSION_READ = {
  matchesAllScopes: ['email-recipient-fatigue-suppression-read']
};
var EMAIL_FATIGUE_SUPRESSION_WRITE = {
  matchesAllScopes: ['email-recipient-fatigue-suppression-write']
}; // Component level access control checks

var BCC_EMAIL_SETTINGS_READ = {
  matchesAllScopes: ['email-access']
};
exports.BCC_EMAIL_SETTINGS_READ = BCC_EMAIL_SETTINGS_READ;
var BCC_EMAIL_SETTINGS_WRITE = {
  and: [BCC_EMAIL_WRITE]
};
exports.BCC_EMAIL_SETTINGS_WRITE = BCC_EMAIL_SETTINGS_WRITE;
var DEFAULT_SETTINGS_WRITE = {
  and: [{
    matchesAllScopes: ['email-core-api-access']
  }, {
    matchesAllScopes: ['email-write']
  }, EMAIL_SETTINGS_READ]
};
exports.DEFAULT_SETTINGS_WRITE = DEFAULT_SETTINGS_WRITE;
var COLOR_SETTINGS_READ = {
  or: [SITE_SETTINGS_READ]
};
exports.COLOR_SETTINGS_READ = COLOR_SETTINGS_READ;
var COLOR_SETTINGS_WRITE = {
  or: [SITE_SETTINGS_WRITE]
};
exports.COLOR_SETTINGS_WRITE = COLOR_SETTINGS_WRITE;
var COLOR_PICKER_SETTINGS_READ = {
  or: [COLOR_SETTINGS_READ, EMAIL_SETTINGS_READ]
};
exports.COLOR_PICKER_SETTINGS_READ = COLOR_PICKER_SETTINGS_READ;
var COLOR_PICKER_SETTINGS_WRITE = {
  or: [COLOR_SETTINGS_WRITE, DEFAULT_SETTINGS_WRITE]
};
exports.COLOR_PICKER_SETTINGS_WRITE = COLOR_PICKER_SETTINGS_WRITE;
var DEFAULT_SETTINGS_READ = {
  and: [EMAIL_SETTINGS_READ]
};
exports.DEFAULT_SETTINGS_READ = DEFAULT_SETTINGS_READ;
var DOUBLE_OPTIN_READ = {
  and: [DOI_PAGES_READ, DOI_SETTINGS_READ, LANDING_PAGES_READ, SUBSCRIPTION_EMAILS_READ]
};
exports.DOUBLE_OPTIN_READ = DOUBLE_OPTIN_READ;
var DOUBLE_OPTIN_PANEL = {
  not: {
    matchesAllScopes: ['hub-marketing-product']
  }
};
exports.DOUBLE_OPTIN_PANEL = DOUBLE_OPTIN_PANEL;
var DOUBLE_OPTIN_TURN_OFF = {
  matchesAllScopes: ['marketing-starter-product']
};
exports.DOUBLE_OPTIN_TURN_OFF = DOUBLE_OPTIN_TURN_OFF;
var DOUBLE_OPTIN_WRITE = {
  and: [DOI_PAGES_WRITE, DOI_SETTINGS_WRITE]
};
exports.DOUBLE_OPTIN_WRITE = DOUBLE_OPTIN_WRITE;
var FONT_SETTINGS_READ = {
  and: [SITE_SETTINGS_READ]
};
exports.FONT_SETTINGS_READ = FONT_SETTINGS_READ;
var FONT_SETTINGS_WRITE = {
  and: [SITE_SETTINGS_WRITE]
};
exports.FONT_SETTINGS_WRITE = FONT_SETTINGS_WRITE;
var FOOTER_CARDS_READ = {
  and: [CAN_SPAM_SETTINGS_READ]
};
exports.FOOTER_CARDS_READ = FOOTER_CARDS_READ;
var FOOTER_CARDS_WRITE = {
  and: [CAN_SPAM_SETTINGS_WRITE]
};
exports.FOOTER_CARDS_WRITE = FOOTER_CARDS_WRITE;
var GRAYMAIL_SUPPRESSION_READ = {
  and: [SITE_SETTINGS_READ]
};
exports.GRAYMAIL_SUPPRESSION_READ = GRAYMAIL_SUPPRESSION_READ;
var GRAYMAIL_SUPPRESSION_WRITE = {
  and: [SITE_SETTINGS_WRITE]
};
exports.GRAYMAIL_SUPPRESSION_WRITE = GRAYMAIL_SUPPRESSION_WRITE;
var RESUBSCRIPTION_EMAIL_READ = {
  and: [SITE_SETTINGS_READ, SUBSCRIPTION_EMAILS_READ]
};
exports.RESUBSCRIPTION_EMAIL_READ = RESUBSCRIPTION_EMAIL_READ;
var RESUBSCRIPTION_EMAIL_WRITE = {
  and: [SITE_SETTINGS_WRITE]
};
exports.RESUBSCRIPTION_EMAIL_WRITE = RESUBSCRIPTION_EMAIL_WRITE;
var RSS_DATE_FORMAT_READ = {
  and: [SITE_SETTINGS_READ, BLOG_LANGUAGES_READ]
};
exports.RSS_DATE_FORMAT_READ = RSS_DATE_FORMAT_READ;
var RSS_DATE_FORMAT_WRITE = {
  and: [SITE_SETTINGS_WRITE]
};
exports.RSS_DATE_FORMAT_WRITE = RSS_DATE_FORMAT_WRITE;
var SIZE_SETTINGS_READ = {
  and: [SITE_SETTINGS_READ]
};
exports.SIZE_SETTINGS_READ = SIZE_SETTINGS_READ;
var SIZE_SETTINGS_WRITE = {
  and: [SITE_SETTINGS_WRITE]
};
exports.SIZE_SETTINGS_WRITE = SIZE_SETTINGS_WRITE;
var SMTP_TOKENS_TAB_READ = {
  matchesAllScopes: ['content-access', 'email-access']
};
exports.SMTP_TOKENS_TAB_READ = SMTP_TOKENS_TAB_READ;
var SUBSCRIPTION_PAGE_READ = {
  and: [DESIGN_TEMPLATES_READ, SITE_SETTINGS_READ]
};
exports.SUBSCRIPTION_PAGE_READ = SUBSCRIPTION_PAGE_READ;
var SUBSCRIPTION_PAGE_WRITE = {
  and: [SITE_SETTINGS_WRITE]
};
exports.SUBSCRIPTION_PAGE_WRITE = SUBSCRIPTION_PAGE_WRITE;
var TRACKING_READ = {
  and: [DOMAINS_READ, SITE_SETTINGS_READ]
};
exports.TRACKING_READ = TRACKING_READ;
var TRACKING_WRITE = {
  and: [SITE_SETTINGS_WRITE]
};
exports.TRACKING_WRITE = TRACKING_WRITE;
var TYPES_READ = {
  and: [SUBSCRIPTION_DEFINITIONS_READ]
};
exports.TYPES_READ = TYPES_READ;
var TYPES_WRITE = {
  and: [SUBSCRIPTION_DEFINITIONS_WRITE]
};
exports.TYPES_WRITE = TYPES_WRITE;
var FREQUENCY_READ = {
  and: [EMAIL_FATIGUE_SUPRESSION_READ]
};
exports.FREQUENCY_READ = FREQUENCY_READ;
var FREQUENCY_WRITE = {
  and: [EMAIL_FATIGUE_SUPRESSION_WRITE]
};
exports.FREQUENCY_WRITE = FREQUENCY_WRITE;